import PageTitle from "../../components/PagesComponents/PageTitleSection/PageTitle";

const ProfessionalCourses = () => {
  return (
    <>
    <PageTitle pagetitle="PROFESSIONAL COURSES" />
    <div className=''>
      
    </div></>
  )
}

export default ProfessionalCourses